<script lang="ts">
  import { Dialog as DialogPrimitive } from "bits-ui"
  import { Button } from "$lib/components/ui/button/index.js"
  import { cn, type WithoutChildrenOrChild } from "$lib/utils.js"
  import * as Dialog from "./index.js"
  import DialogPortal from "./dialog-portal.svelte"
  import type { Snippet } from "svelte"
  import type { ComponentProps } from "svelte"
  import XIcon from "@lucide/svelte/icons/x"

  let {
    ref = $bindable(null),
    class: className,
    portalProps,
    children,
    showCloseButton = true,
    ...restProps
  }: WithoutChildrenOrChild<DialogPrimitive.ContentProps> & {
    portalProps?: WithoutChildrenOrChild<ComponentProps<typeof DialogPortal>>;
    children: Snippet;
    showCloseButton?: boolean;
  } = $props()
</script>

<DialogPortal {...portalProps}>
  <Dialog.Overlay>
    <DialogPrimitive.Content
      bind:ref
      data-slot="dialog-content"
      class={cn(
			"w-full max-w-[calc(100%-2rem)] grid gap-6 rounded-xl bg-popover p-6 text-sm text-popover-foreground ring-1 ring-foreground/10 duration-100 sm:max-w-md data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 outline-none",
			className
		)}
      {...restProps}
    >
      {@render children?.()}
      {#if showCloseButton}
        <DialogPrimitive.Close data-slot="dialog-close">
          {#snippet child({ props })}
            <Button variant="ghost" class="absolute top-2 right-2" size="icon-sm" {...props}>
              <XIcon/>
              <span class="sr-only">Close</span>
            </Button>
          {/snippet}
        </DialogPrimitive.Close>
      {/if}
    </DialogPrimitive.Content>
  </Dialog.Overlay>
</DialogPortal>
